import { render, staticRenderFns } from "./ObjectAttribute.vue?vue&type=template&id=20c17884&scoped=true&"
import script from "./ObjectAttribute.vue?vue&type=script&lang=js&"
export * from "./ObjectAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAttribute.vue?vue&type=style&index=0&id=20c17884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c17884",
  null
  
)

export default component.exports